"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _EllipsisDropdown = _interopRequireDefault(require("../../../../../components/shared-components/EllipsisDropdown"));

var _icons = require("@ant-design/icons");

var _Flex = _interopRequireDefault(require("../../../../../components/shared-components/Flex"));

var _utils = _interopRequireDefault(require("../../../../../utils"));

var _config = _interopRequireDefault(require("../../../../../config.json"));

var _axios = _interopRequireDefault(require("axios"));

var _moreTableRMData = _interopRequireDefault(require("./moreTableRMData"));

var _moreTableParentData = _interopRequireDefault(require("./moreTableParentData"));

var _reactCsv = require("react-csv");

var _errorPage = _interopRequireDefault(require("./../../../../error-views/errorPage"));

// import { useHistory } from 'react-router';
// const innerwidth = window.innerWidth;
var TableData = function TableData(_ref) {
  var data = _ref.data;
  var date = new Date();
  var today = "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
  var time = "".concat(date.getHours(), ":").concat(date.getMinutes());
  var header = [{
    label: "date",
    key: "date"
  }, {
    label: "CLcode",
    key: "CLcode"
  }, {
    label: "rmcodeMath",
    key: "rmcode"
  }, {
    label: "rmcodeEng",
    key: "RMcodeEnglish"
  }, {
    label: "rmauditpercent",
    key: "rmauditpercent"
  }, {
    label: "parentauditpercent",
    key: "parentauditpercent"
  }, {
    label: "RMAuditPercentEnglish",
    key: "RMAuditPercentEnglish"
  }];
  var csvRport = {
    filename: "Audit Data " + today + " " + time,
    headers: header,
    data: data
  }; // const history = useHistory();

  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token");

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      apiError = _useState2[0],
      setapiError = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0, _react.useState)(data),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      tableData = _useState6[0],
      setTableData = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      RMModel = _useState8[0],
      setRMAuditModel = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      parentModel = _useState10[0],
      setParentModel = _useState10[1]; // const [record, setRecord] = useState({});


  var _useState11 = (0, _react.useState)({}),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 1),
      setRecord = _useState12[0];

  var _useState13 = (0, _react.useState)([]),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      MoreData = _useState14[0],
      setMoreData = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      Available = _useState16[0],
      setAvailable = _useState16[1];

  var columns = [{
    title: "Date",
    dataIndex: "date",
    key: "date",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'date');
    }
  }, {
    title: "RMCode Math",
    dataIndex: "rmcode",
    key: "rmcode",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'rmcode');
    }
  }, {
    title: "Math Audit Score",
    dataIndex: "rmauditpercent",
    key: "rmauditpercent",
    fixed: "left",
    render: function render(_, record) {
      return record.rmauditpercent ? record.rmauditpercent : "No Score";
    },
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'rmauditpercent');
    }
  }, {
    title: "Parent Audit Score",
    dataIndex: "parentauditpercent",
    key: "parentauditpercent",
    fixed: "left",
    render: function render(_, record) {
      return record.parentauditpercent ? record.parentauditpercent : "No Score";
    },
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'parentauditpercent');
    }
  }, {
    title: "RMCode Eng",
    dataIndex: "RMcodeEnglish",
    key: "RMcodeEnglish",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'RMcodeEnglish');
    },
    render: function render(_, record) {
      return record.RMcodeEnglish ? record.RMcodeEnglish : "No RMCode";
    }
  }, {
    title: "Eng Audit Score",
    dataIndex: "RMAuditPercentEnglish",
    key: "RMAuditPercentEnglish",
    fixed: "left",
    render: function render(_, record) {
      return record.RMAuditPercentEnglish ? record.RMAuditPercentEnglish : "No Score";
    },
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'RMAuditPercentEnglish');
    }
  }, {
    title: 'Action',
    dataIndex: 'actions',
    fixed: "left",
    render: function render(_, elm) {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_EllipsisDropdown.default, {
        menu: dropdownMenu(elm)
      }));
    }
  }];

  var dropdownMenu = function dropdownMenu(elm) {
    return /*#__PURE__*/_react.default.createElement(_antd.Menu, null, /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, null, /*#__PURE__*/_react.default.createElement(_Flex.default, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ml-2",
      onClick: function onClick() {
        return showRMData(elm, 'Math');
      }
    }, /*#__PURE__*/_react.default.createElement(_icons.FileOutlined, {
      className: "mr-1"
    }), "Math Audit Details"))), /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, null, /*#__PURE__*/_react.default.createElement(_Flex.default, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ml-2",
      onClick: function onClick() {
        return showRMData(elm, 'Eng');
      }
    }, /*#__PURE__*/_react.default.createElement(_icons.FileOutlined, {
      className: "mr-1"
    }), "Eng Audit Details"))), /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, null, /*#__PURE__*/_react.default.createElement(_Flex.default, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ml-2",
      onClick: function onClick() {
        return showParentData(elm);
      }
    }, /*#__PURE__*/_react.default.createElement(_icons.FileOutlined, {
      className: "mr-1"
    }), "Parent Audit Details"))));
  }; // useEffect(async () => {
  //   setTableData(data);
  //   setLoading(false)
  // }, [data]);


  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setTableData(data);
                setLoading(false);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData(); // eslint-disable-next-line 
  }, [data]);

  var showRMData = function showRMData(elm, str) {
    setRecord(elm);
    var url;

    if (str === 'Math') {
      url = _config.default.getRMMathAudit + cl + '&date=' + elm.date + '&RMcode=' + elm.rmcode;
    } else if (str === 'Eng') {
      url = _config.default.getRMEngAudit + cl + '&date=' + elm.date + '&RMcode=' + elm.RMcodeEnglish;
    }

    _axios.default.get(url, {
      headers: {
        'Authorization': token
      }
    }).then(function (resp) {
      if (resp.data.status === "error") setapiError(resp.data);

      if (resp.data.length > 0) {
        var details = resp.data;
        details.forEach(function (d2) {
          if (d2.auditdate) {
            var convertDate = formatDate(d2.auditdate);
            d2.auditdate = convertDate;
          }
        });
        setMoreData(details);
        setAvailable(false);
        setRMAuditModel(true);
      } else {
        setAvailable(true);
        setRMAuditModel(false);
      }
    }, function (error) {
      setapiError(error.response);
    });
  };

  function formatDate(date) {
    var d = new Date(date);
    var month = '' + (d.getMonth() + 1);
    var day = '' + d.getDate();
    var year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  var showParentData = function showParentData(elm) {
    var url = _config.default.getAuditListParent + cl + '&date=' + elm.date + '&RMcode=' + elm.rmcode;

    _axios.default.get(url, {
      headers: {
        'Authorization': token
      }
    }).then(function (resp) {
      if (resp.data.status === "error") setapiError(resp.data);

      if (resp.data.length > 0) {
        var details = resp.data;
        details.forEach(function (d2) {
          if (d2.auditdate) {
            var convertDate = formatDate(d2.auditdate);
            d2.auditdate = convertDate;
          }
        });
        setMoreData(details);
        setAvailable(false);
        setParentModel(true);
      } else {
        setAvailable(true);
        setParentModel(false);
      }
    }, function (error) {
      setapiError(error.response);
    });
  };

  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "Loading..."
  }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "History of Audit",
    extra: /*#__PURE__*/_react.default.createElement(_reactCsv.CSVLink, csvRport, /*#__PURE__*/_react.default.createElement(_icons.DownloadOutlined, {
      style: {
        'fontSize': 30
      }
    }))
  }, /*#__PURE__*/_react.default.createElement(_antd.Table, {
    columns: columns,
    dataSource: tableData,
    rowKey: "date"
  }), /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    title: "RM Audit Data",
    visible: RMModel,
    onOk: function onOk() {
      return setRMAuditModel(false);
    },
    onCancel: function onCancel() {
      return setRMAuditModel(false);
    },
    width: 1200,
    bodyStyle: {
      overflowY: 'scroll',
      height: 500
    },
    cancelButtonProps: {
      hidden: true
    }
  }, /*#__PURE__*/_react.default.createElement(_moreTableRMData.default, {
    MoreData: MoreData
  })), /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    title: "Parent Audit Data",
    visible: parentModel,
    onOk: function onOk() {
      return setParentModel(false);
    },
    onCancel: function onCancel() {
      return setParentModel(false);
    },
    width: 1200,
    cancelButtonProps: {
      hidden: true
    }
  }, /*#__PURE__*/_react.default.createElement(_moreTableParentData.default, {
    MoreData: MoreData
  })), /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    title: "Audit Data",
    visible: Available,
    onOk: function onOk() {
      return setAvailable(false);
    },
    onCancel: function onCancel() {
      return setAvailable(false);
    },
    cancelButtonProps: {
      hidden: true
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, null, /*#__PURE__*/_react.default.createElement(_antd.Empty, null)))));
};

var _default = TableData;
exports.default = _default;